import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import parse from "html-react-parser";
import { Button } from "../Button/Button";

const styles = require("./ResourcePanel.module.scss");

const ResourcePanel = (props) => {
  const {
    title,
    copy,
    image,
    button,
    buttonClick = null,
    buttonColor = "black",
  } = props;

  return (
    <div className={styles.resourcePanel}>
      <div className={styles.panelImage} data-element="resource-image-wrap">
        <GatsbyImage image={image.localFile.childImageSharp.gatsbyImageData} />
      </div>

      <div className={styles.copy}>
        <h4>{title}</h4>
        <p>{parse(copy)}</p>
      </div>
      <Button
        label={button.text}
        icon={button.icon.localFile.publicURL}
        handleOnClick={buttonClick}
        bkgColor={buttonColor}
      ></Button>
    </div>
  );
};

export default ResourcePanel;
